/// <reference types="new-relic-browser" preserve="true" />

import { Logger } from "../common/types";
import { isError } from "../common/isError";

/* eslint-disable no-var */
declare global {
  var NREUM: typeof newrelic;
}
/* eslint-enable no-var */

const reportToNewRelic: typeof newrelic.noticeError = (
  error,
  customAttributes,
) => {
  if (typeof NREUM === "object") {
    NREUM.noticeError(error, customAttributes);
  }
};

export const parseError = (error: unknown): Error | string => {
  if (isError(error) || typeof error === "string") {
    return error;
  }
  return JSON.stringify(error);
};

export const createBrowserLogger = (
  reportToNewRelic: typeof newrelic.noticeError,
): Logger => ({
  error: (args) => {
    console.error(args);
    const { error, description, customAttributes } = args;
    const customAttributesAndDescription =
      customAttributes || description
        ? {
            ...(customAttributes ? customAttributes : {}),
            ...(description ? { description } : {}),
          }
        : undefined;
    reportToNewRelic(parseError(error), customAttributesAndDescription);
  },
  log: (message) => console.log(message),
});

export default createBrowserLogger(reportToNewRelic);
